import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';
import ElectronicDPNCancellation, {
	ElectronicDPNCancellationValues,
} from './ElectronicDPNCancellation';
import { Size } from '../../../../../Enums/Size.enum';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: (values: ElectronicDPNCancellationValues) => void;
	electronicConfirmation?: any;
}

const ElectronicDPNCancellationModal: React.FC<Props> = ({
	isOpen,
	onClose,
	onSubmit,
	electronicConfirmation,
}) => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={Size.SM}>
			<Modal.Header
				title='nczi.electronicDPNCancellation.cancelRecord'
				firstUpper
			/>
			<Modal.Content contentScroll>
				<ElectronicDPNCancellation
					onSubmit={onSubmit}
					electronicConfirmation={electronicConfirmation}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default ElectronicDPNCancellationModal;
